import {
  msSaveECDARegGiroApplication,
  msGetEcdaRegistrationChildBalanceSheet,
  msGetECDAGiroFormUploadURL,
  msSkipGiroForECDA,
} from 'services/RegistrationsService';
import { msGetECDARegistrationRefundChildBalance } from 'services/FinanceService';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { actionHandlerWithFeatureFlag, parseGraphQLError } from '../../utils';
import {
  SAVE_ECDA_REG_GIRO_APPLICATION,
  GET_ID_DOCUMENT_TYPE_CONFIG_ECDA_GIRO_URL,
  MARK_GIRO_AS_COMPLETED_ECDA,
  SKIP_GIRO_ECDA,
  GET_ECDA_REGISTRATION_CHILD_BALANCE_SHEET,
  TRANSFER_ECDA_REG_CHILD_BALANCE,
  FIND_ALL_ECDA_REG_CHILD_REFUNDS,
} from '../models/financeModelECDA';
import {
  FETCH_ALL_REG_CHILD_REFUNDS_ERROR,
  FETCH_ALL_REG_CHILD_REFUNDS_LOADING,
  FETCH_ALL_REG_CHILD_REFUNDS_SUCCESS,
} from './actionTypes';
import DatadogHandler from '../../utils/datadog';
import { FEATURE_FLAGS } from '../../utils/constants';
import {
  msCompleteGiroSetupECDA,
  msTransferEcdaRegistrationChildBalance,
} from '../../services/FinanceService';

const fileName = 'src/redux/actions/FinanceECDA.js';

export const monoSaveECDARegGiroApplication = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: SAVE_ECDA_REG_GIRO_APPLICATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSaveECDARegGiroApplication',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const saveECDARegGiroApplication = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSaveECDARegGiroApplication,
      monoHandler: monoSaveECDARegGiroApplication,
      extraData: reqData,
    }
  );
};

export const monoGetECDAGiroFormUploadURL = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: GET_ID_DOCUMENT_TYPE_CONFIG_ECDA_GIRO_URL,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDAGiroFormUploadURL',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const getECDAGiroFormUploadURL = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetECDAGiroFormUploadURL,
      monoHandler: monoGetECDAGiroFormUploadURL,
      extraData: reqData,
    }
  );
};

export const monoCompleteGiroSetupECDA = async (_, reqData) => {
  try {
    const { IDEcdaRegistration } = reqData;
    return SkApolloRequest({
      params: {
        mutation: MARK_GIRO_AS_COMPLETED_ECDA,
        variables: { IDEcdaRegistration },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCompleteGiroSetupECDA',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const completeGiroSetupECDA = IDEcdaRegistration => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCompleteGiroSetupECDA,
      monoHandler: monoCompleteGiroSetupECDA,
      extraData: { IDEcdaRegistration },
    }
  );
};

export const monoSkipGiroForECDA = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: SKIP_GIRO_ECDA,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoSkipGiroForECDA',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const skipGiroForECDA = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msSkipGiroForECDA,
      monoHandler: monoSkipGiroForECDA,
      extraData: reqData,
    }
  );
};

export const monoGetEcdaRegistrationChildBalanceSheet = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: GET_ECDA_REGISTRATION_CHILD_BALANCE_SHEET,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetEcdaRegistrationChildBalanceSheet',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};
export const getEcdaRegistrationChildBalanceSheet = async reqData => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msGetEcdaRegistrationChildBalanceSheet,
      monoHandler: monoGetEcdaRegistrationChildBalanceSheet,
      extraData: reqData,
    }
  );
};

export const monoTransferEcdaRegistrationChildBalance = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: TRANSFER_ECDA_REG_CHILD_BALANCE,
        variables: { dto: reqData },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoTransferEcdaRegistrationChildBalance',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const transferEcdaRegistrationChildBalance = async reqData => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msTransferEcdaRegistrationChildBalance,
      monoHandler: monoTransferEcdaRegistrationChildBalance,
      extraData: reqData,
    }
  );
};

const allECDARegChildRefundsLoading = () => ({
  type: FETCH_ALL_REG_CHILD_REFUNDS_LOADING,
  key: 'allECDARegChildRefunds',
  value: {
    inProgress: true,
  },
});

const allECDARegChildRefundsSuccess = data => ({
  type: FETCH_ALL_REG_CHILD_REFUNDS_SUCCESS,
  key: 'allECDARegChildRefunds',
  value: {
    inProgress: false,
    data,
  },
});

const allECDARegChildRefundsError = error => ({
  type: FETCH_ALL_REG_CHILD_REFUNDS_ERROR,
  key: 'allECDARegChildRefunds',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

export const monoGetECDARegistrationRefundChildBalance = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: FIND_ALL_ECDA_REG_CHILD_REFUNDS,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDARegistrationRefundChildBalance',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: ex.message,
    };
  }
};

export const getECDARegistrationRefundChildBalance =
  reqData => async dispatch => {
    dispatch(allECDARegChildRefundsLoading());
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetECDARegistrationRefundChildBalance,
        monoHandler: monoGetECDARegistrationRefundChildBalance,
        extraData: reqData,
      }
    );
    if (resp.success) {
      dispatch(allECDARegChildRefundsSuccess(resp.data));
    } else {
      dispatch(allECDARegChildRefundsError(resp.error));
    }

    return resp;
  };
